"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.getPriceTextStyle = exports.getPriceLabel = exports.getOriginalPrice = exports.getLabelTextStyle = exports.defaultProps = exports.default = exports.Price = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _conditionalAttributes = require("../../util/conditionalAttributes/conditionalAttributes");
var _renderObject = require("../../util/renderObject/renderObject");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Price component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns Price
 */

const Price = props => {
  const {
    appDownloadLabel,
    appDownloadAction,
    externalAppDownloadAction,
    kitPrice,
    kitPriceAccessibilityLabel,
    // comes from web-site already interpolated with kit price
    listPrice,
    listPriceAccessibilityLabel,
    // comes from web-site already interpolated with list price
    message,
    originalPriceLabel,
    priceLabel,
    salePrice,
    salePriceAccessibilityLabel,
    // comes from web-site already interpolated with sale price
    variant = defaultProps.variant,
    disabled
  } = props;
  if (!salePrice && !listPrice && !variant) {
    return null;
  }

  /* Price utility functions */
  const labelStyle = getLabelTextStyle({
    variant: variant
  });
  const newPriceLabel = getPriceLabel({
    label: priceLabel,
    labelStyle: labelStyle
  });
  const originalPrice = getOriginalPrice({
    tokenizedString: originalPriceLabel,
    listPrice: listPrice,
    listPriceAccessibilityLabel: listPriceAccessibilityLabel
  });
  const priceTextStyle = getPriceTextStyle({
    variant: variant
  });

  /* Price return checks */
  const appOnly = appDownloadLabel && appDownloadAction;
  const hasKitNoLabel = kitPrice && salePrice && !newPriceLabel;
  const hasPriceNoSale = listPrice && !salePrice;
  const hasPriceAndSale = listPrice && salePrice;

  /**
   * Represents a kitPriceContent function
   * This function will render the kitPrice
   * @method
   * @returns kitPriceContent
   */

  const kitPriceContent = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-Price__kitPrice"
    }, kitPriceAccessibilityLabel && /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, kitPriceAccessibilityLabel), /*#__PURE__*/_react.default.createElement(_Text.default, _extends({
      htmlTag: "span",
      textColor: "xsubtle",
      textStyle: "label-sm"
    }, (0, _conditionalAttributes.conditionalAttributes)({
      ariaHidden: kitPriceAccessibilityLabel ? true : undefined
    })), kitPrice));
  };
  const componentClassName = (0, _classnames.default)('pal-c-Price', {
    [`pal-c-Price--${variant}`]: variant,
    [`pal-c-Price--salePrice`]: salePrice,
    [`pal-c-Price--disabled`]: disabled,
    [`pal-c-Price--priceLabel`]: priceLabel,
    [`pal-c-Price--appOnly`]: appOnly
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasPriceNoSale && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Price__priceContainer"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    textStyle: priceTextStyle
  }, listPrice), kitPrice && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, kitPriceContent())), hasPriceAndSale && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Price__saleContainer"
  }, salePriceAccessibilityLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, salePriceAccessibilityLabel), /*#__PURE__*/_react.default.createElement(_Text.default, _extends({
    htmlTag: "span",
    textColor: "brand-02-strong",
    textStyle: priceTextStyle
  }, (0, _conditionalAttributes.conditionalAttributes)({
    ariaHidden: salePriceAccessibilityLabel ? true : undefined
  })), salePrice), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Price__originalPrice"
  }, listPriceAccessibilityLabel && /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, listPriceAccessibilityLabel), originalPrice)), hasKitNoLabel && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, kitPriceContent()), newPriceLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Price__labelContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "pal-c-Price__priceLabel"
  }, newPriceLabel), kitPrice && salePrice && newPriceLabel && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, kitPriceContent())), appOnly && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Price__appOnly"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    "aria-hidden": true,
    name: "Wallet",
    size: "lg"
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    textStyle: "label-sm",
    textColor: "xsubtle"
  }, appDownloadLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-Price__appOnly--links"
  }, externalAppDownloadAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalAppDownloadAction)), !externalAppDownloadAction && /*#__PURE__*/_react.default.createElement(_Link.default, {
    href: appDownloadAction.href,
    label: appDownloadAction.label,
    size: "compact"
  }))), !listPrice && /*#__PURE__*/_react.default.createElement("span", {
    className: "pal-c-Price__noPrice"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "p",
    textColor: "xsubtle",
    textStyle: "label-sm"
  }, message)));
};

/**
 * @method getOriginalPrice
 * @summary This method will build the original price string
 * @param {string} data.tokenizedString - originalPriceLabel value tokenized string
 * @param {string} data.listPrice - listPrice value
 */
exports.Price = Price;
const getOriginalPrice = data => {
  const {
    tokenizedString,
    listPrice,
    listPriceAccessibilityLabel
  } = data;
  if (!listPrice) {
    return null;
  }
  const originalListPrice = /*#__PURE__*/_react.default.createElement(_Text.default, _extends({
    htmlTag: "span",
    textColor: "xsubtle",
    textDecoration: "line-through",
    textStyle: "body-sm"
  }, (0, _conditionalAttributes.conditionalAttributes)({
    ariaHidden: listPriceAccessibilityLabel ? true : undefined
  })), listPrice);
  if (!tokenizedString || tokenizedString && !tokenizedString.includes('%')) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, originalListPrice);
  }
  const tokenStringLength = tokenizedString.length;
  const tokenIndex = tokenizedString.indexOf('%');
  const origContent = tokenIndex > 0 ? tokenizedString.substring(0, tokenIndex) : tokenizedString.substring(2, tokenStringLength);
  const origLabel = /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    textStyle: "body-sm",
    textColor: "xsubtle",
    ariaHidden: true
  }, origContent);
  return tokenIndex > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, origLabel, originalListPrice) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, originalListPrice, origLabel);
};

/**
 * Function to get price textStyle based on variant
 * @method
 * @param {Object} event
 * @returns { String } // string for textStyle variant
 */
exports.getOriginalPrice = getOriginalPrice;
const getLabelTextStyle = data => {
  const {
    variant
  } = data;
  let newLabelTextStyle = '';
  switch (variant) {
    case 'default':
      newLabelTextStyle = 'label';
      break;
    case 'PDP':
    case 'large':
      newLabelTextStyle = 'label-sm';
      break;
    default:
      newLabelTextStyle = 'label';
  }
  return newLabelTextStyle;
};

/**
 * Function to get price textStyle based on variant
 * @method
 * @param {Object} event
 * @returns { String } // string for textStyle variant
 */
exports.getLabelTextStyle = getLabelTextStyle;
const getPriceTextStyle = data => {
  const {
    variant
  } = data;
  let newPriceTextStyle = '';
  switch (variant) {
    case 'default':
      newPriceTextStyle = 'body-lg';
      break;
    case 'PDP':
      newPriceTextStyle = 'title-lg';
      break;
    case 'large':
      newPriceTextStyle = 'title';
      break;
    default:
      newPriceTextStyle = 'body-lg';
  }
  return newPriceTextStyle;
};

/**
 * @method getPriceLabel
 * @summary This method will build the Price Label
 * @param {label} data.label - label value
 */
exports.getPriceTextStyle = getPriceTextStyle;
const getPriceLabel = data => {
  const {
    label,
    labelStyle
  } = data;
  if (!label) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "p",
    textColor: "brand-02-strong",
    textStyle: labelStyle
  }, label);
};

/**
 * Property type definitions
 *
 * @type {object}
 * @property {string} appDownloadLabel - Sets the app download label to display
 * @property {object} appDownloadAction - Sets the app download action
 * @property {boolean} disabled - Sets the disabled state of the price
 * @property {object} externalAppDownloadAction - Sets the app download action from web-site
 * @property {string} kitPrice - Sets the kit value to display
 * @property {string} kitPriceAccessibilityLabel - Sets the kit price accessibility label for screen readers
 * @property {string} listPrice - Sets the list price to display
 * @property {string} listPriceAccessibilityLabel - Sets the list price accessibility label for screen readers
 * @property {string} message - Sets the message to display when there is no price
 * @property {string} originalPriceLabel - Sets the original price text to display with list price
 * @property {string} priceLabel - Sets the price label to display
 * @property {string} salePrice - Sets the sale price to display
 * @property {string} salePriceAccessibilityLabel - Sets the sale price accessibility label for screen readers
 * @property {string} variant - sets the variation of price
 */
exports.getPriceLabel = getPriceLabel;
const propTypes = exports.propTypes = {
  /**
   * Sets the app download label to display
   */
  appDownloadLabel: _propTypes.default.string,
  /**
   * Sets the app download action
   */
  appDownloadAction: _propTypes.default.object,
  /**
   * Sets the disabled state of the price
   */
  disabled: _propTypes.default.bool,
  /**
   * Sets the app download action from web-site
   */
  externalAppDownloadAction: _propTypes.default.object,
  /**
   * Sets the kit value to display
   */
  kitPrice: _propTypes.default.string,
  /**
   * Sets the kit price accessibility label for screen readers
   */
  kitPriceAccessibilityLabel: _propTypes.default.string,
  /**
   * Sets the list price to display
   */
  listPrice: _propTypes.default.string,
  /**
   * Sets the list price accessibility label for screen readers
   */
  listPriceAccessibilityLabel: _propTypes.default.string,
  /**
   * Sets the message to display when there is no price
   */
  message: _propTypes.default.string,
  /**
   * Sets the original price text to display with list price
   */
  originalPriceLabel: _propTypes.default.string,
  /**
   * Sets the price label to display
   */
  priceLabel: _propTypes.default.string,
  /**
   * Sets the sale price to display
   */
  salePrice: _propTypes.default.string,
  /**
   * Sets the sale price accessibility label for screen readers
   */
  salePriceAccessibilityLabel: _propTypes.default.string,
  /**
   * Determines the variation of Price
   * - **PDP:** renders the right size for PDP
   * - **default:** renders the right size for default
   * - **large:** renders the right size for Homepage
   */
  variant: _propTypes.default.oneOf(['default', 'PDP', 'large'])
};

/**
 * Property type definitions
 * @type {object}
 * @property {string} appDownloadLabel=undefined - set the default value of appDownloadLabel
 * @property {object} appDownloadAction=undefined - set the default value of appDownloadAction
 * @property {boolean} disabled=false - set the default value for disabled
 * @property {object} externalAppDownloadAction=undefined - set the default value of externalAppDownloadAction
 * @property {string} kitPrice=undefined - set the default value of kitPrice
 * @property {string} kitPriceAccessibilityLabel=undefined - set the default value of kitPriceAccessibilityLabel
 * @property {string} listPriceAccessibilityLabel=undefined - set the default value of listPriceAccessibilityLabel
 * @property {string} listPrice=undefined - set the default value of listPrice
 * @property {string} message=undefined - set the default value of message
 * @property {string} originalPriceLabel=undefined - set the default value of originalPriceLabel
 * @property {string} priceLabel=undefined - set the default value of priceLabel
 * @property {string} salePrice=undefined - set the default value of salePrice
 * @property {string} salePriceAccessibilityLabel=undefined - set the default value of salePriceAccessibilityLabel
 * @property {string} variant='default' - set the default value of variant
 */
const defaultProps = exports.defaultProps = {
  variant: 'default'
};
Price.propTypes = propTypes;
var _default = exports.default = Price;